/** Builder v2 (brief docs/briefs/forms-builder-v2.md, "The embed"; red team report findings 27 and 28): the exact lines the builder's "Embed in
 *  your page" row prints, one truth for the row, the help article and the tests.
 *
 *  In plain words: the **one line** is a single script tag carrying the form's address (`data-omnabase-form`, the same attribute as the
 *  container's); the script draws the form right where that tag stands. **Place it anywhere** is round two's two lines: an empty container
 *  where the form should appear, and the plain script once per page. `data-project` appears only when a project is given: by default the
 *  form's own rule decides, so moving the form's default project later moves every embed with it (question 10). */

/** where customers load the embed from (the app host, as the help article prints it) */
export const FORM_SCRIPT_URL = "https://app.omnabase.com/forms.js";

/** a value made safe for a double-quoted HTML attribute */
const attr = (v: string): string => v.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export type FormEmbedSnippets = { /** the one-line embed */ line: string; /** "Place it anywhere": the container, then the plain script */ lines: [string, string] };

/** the embed row's snippets for `<workspace>/<form>`, with `data-project` only when a project is given */
export function formEmbedSnippets({ workspace, form, project }: { workspace: string; form: string; project: string | null }): FormEmbedSnippets {
  const target = ` data-omnabase-form="${attr(`${workspace}/${form}`)}"${project ? ` data-project="${attr(project)}"` : ""}`;
  return {
    line: `<script src="${FORM_SCRIPT_URL}"${target} async></script>`,
    lines: [`<div${target}></div>`, `<script src="${FORM_SCRIPT_URL}" async></script>`],
  };
}
